

const handle = (e) => {
    if (e && e.response && e.response.data && e.response.data.status == 400 && e.response.data.type === "https://touristik-vertrieb.at/validation-error") {
        let errors = e.response.data.detail.split(';')
            .map(m => { return { key: "validation-error", value: m } });
        return { handled: true, errors: errors };
    }
    return { handled: false };
}


export default {
    handle
}